import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {ref} from 'vue'

import ListRemoteWritersTable from "@/components/app/ListRemoteWritersTable.vue";
import RemoteWritersForm from "@/components/app/RemoteWritersForm.vue"

// Define component properties

export default /*#__PURE__*/_defineComponent({
  __name: 'RemoteWritersView',
  setup(__props) {

const writersTable = ref()

// Define functions
function handleItemCreated(item: any) {
  writersTable.value.reload()
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(RemoteWritersForm, { onItemCreated: handleItemCreated }),
    _createVNode(ListRemoteWritersTable, {
      ref_key: "writersTable",
      ref: writersTable
    }, null, 512)
  ], 64))
}
}

})